import { MailToLink } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Contact } from '../../interfaces/Contact';
import Section from '../../../../components/Section';

export interface EmailProps {
  contact: Contact;
}

const Email: FC<EmailProps> = ({ contact }) => {
  const { t } = useTranslation('ContactUsPage');

  return (
    contact && contact.email ?
      <Section name={t('email')}>
        <MailToLink email={contact.email}>{contact.email}</MailToLink>
      </Section>
      : null
  );
};

export default Email;
